import React from "react";
import {components} from "react-select";
import {get, set, forOwn, omit} from "lodash";
import Flag from "../../../../display/Flag";
import {SelectDynamicValueFunction} from "../../index";

/**
 * Select option replacement component using Flag component
 * @description Use this as an Option component replacement for the SelectInput (react-select) component. You can pass
 * Label component props through 'labelProps' prop of the SelectInput component. These prop can be an instance of
 * SelectDynamicValueFunction class if prop should depend on option data.
 *
 * @param {Object} props - Option props sent by the react-select component to all the options.
 * @return {JSX.Element}
 * @constructor
 */
const FlagOptionComponent = props => {
	const labelProps = get(props, 'selectProps.labelProps', {});

	// If any prop is an instance of SelectDynamicValueFunction class, call the inner func and pass the option data to it 
	// to get the actual value
	let flagComponentProps = {};
	forOwn(labelProps, (value, key) => {
		if (value instanceof SelectDynamicValueFunction) {
			try { set(flagComponentProps, key, value.func(props.data)); } 
			catch (e) { omit(flagComponentProps, [key]); }
		}
		else set(flagComponentProps, key, value);
	});
	
	return (
		<components.Option {...props}>
			{flagComponentProps ? <Flag {...flagComponentProps} /> : null} {props.label}
		</components.Option>
	)
};

export default FlagOptionComponent;